mutation PublishVariationsXmlFeed(
    $campaignId: ID!
    $platform: String!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $rebuild: Boolean
) {
    publishVariationsXmlFeed(
        campaignId: $campaignId
        platform: $platform
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
        rebuild: $rebuild
    )
}
